import {
    API,
    DynamicLoadManualManager,
    DynamicLoadManualStaticSubappAndSpa,
    getGlobalEventBus,
    Microfrontend,
  } from '@gruposantander/mb-ui-framework';
  import { LoadingSection } from 'commonsComponents/loadingSection';
  import PropTypes from 'prop-types';
  import React, { useEffect, useState } from 'react';
  import { useHistory } from 'react-router-dom';
  import { cookies } from '../utilities/storage';
  import { COOKIE_KEYS } from './constants/session';
  
  
class CustomUrlProvider {
  constructor(customUrl) {
    this.customUrl = customUrl;
  }

  getCustomUrl() {
    return this.customUrl;
  }
}

  const BaseMicrofrontendRoute = ({
    microfront,
    variant,
    projectId,
    customUrl,
    initTranslationsMB,
    featureFlagsMB
  }) => {
    const history = useHistory();
    const eventBus = getGlobalEventBus()
   


// Use custom provider
const customProvider = new CustomUrlProvider(customUrl);
const loader = new DynamicLoadManualManager(new DynamicLoadManualStaticSubappAndSpa(variant, projectId).setURLProvider(customProvider));
    
  // Manually getting cookies because the authenticator session might not be accessing the same environment.
  // This ensures that the session data matches what we have in the store.  
  const sessionData = COOKIE_KEYS.reduce((data, key) => {
    data[key] = cookies.get(key);
    return data;
  }, {}); 
  
  sessionData.accessToken = cookies.get("tokenCredential");  
  sessionData.sessionExpiresAt = new Date(cookies.get("sessionExpiresAt"))

  const flagsMap = new Map(Object.entries(featureFlagsMB ? featureFlagsMB.toJS() : {}));
  const initTranslations = initTranslationsMB ? initTranslationsMB.toJS() : {};
  const translations= {
    web: initTranslations.web ,  
    config: initTranslations.config
  }

  if (!initTranslations.web || !initTranslations.config) {
      return <LoadingSection type="round" width={80} />;
  }
  
    return (
      <Microfrontend
        id={microfront}
        data={{
          history,
          store: {},
          externalComponents: {},
          initializedFeatures: {},
          data: {
            history,
            featureFlag:flagsMap,
            eventBus,
            sessionData,
            translations:translations,
          },
        }}
        loader={loader}
        onLoad={() => {
          console.log(`${microfront} Loaded`);
        }}
      />
    );
  };
  
  BaseMicrofrontendRoute.propTypes = {
    microfront: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    translationsConfig: PropTypes.object.isRequired,
    featureFlagConfig: PropTypes.object.isRequired,
  };
  
  export default  React.memo(BaseMicrofrontendRoute)